import { render, staticRenderFns } from "./MegaMenuItem.vue?vue&type=template&id=715124de&scoped=true&"
import script from "./MegaMenuItem.vue?vue&type=script&lang=js&"
export * from "./MegaMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenuItem.vue?vue&type=style&index=0&id=715124de&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715124de",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MegaMenuColumns: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/mega-menu/MegaMenuColumns.vue').default})
